module.exports = __webpack_public_path__ + "static/bebauung2-68582b44ca466b9aad0f23e48399b7a8.png";